import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import OfferInvestmentCard from './OfferInvestmentCard';
import { offerInvestmentsQuery } from '../../apollo';

const OfferInvestments = ({
  issuerCompany,
  toggleInvestment,
  data: { loading, error, offerInvestments },
}) => {
  if (loading) return <div className='sub-header'>Loading...</div>;
  if (error)
    return (
      <div className='sub-header'>
        Error Loading Investments, please try again.
      </div>
    );
  if (!offerInvestments.length)
    return (
      <div className='sub-header'>
        You have no investments with {issuerCompany.name}
      </div>
    );

  return (
    <Fragment>
      <div className='sub-header'>Investments with {issuerCompany.name}</div>
      <div className='docu-card-wrapper'>
        {offerInvestments &&
          offerInvestments.map((investment) => (
            <OfferInvestmentCard
              key={investment._id}
              investment={investment}
              toggleInvestment={toggleInvestment}
            />
          ))}
      </div>
    </Fragment>
  );
};

OfferInvestments.propTypes = {
  data: PropTypes.object.isRequired,
  issuerCompany: PropTypes.object.isRequired,
  toggleInvestment: PropTypes.func.isRequired,
};

export default withRouter(
  compose(
    graphql(offerInvestmentsQuery, {
      options: ({ match }) => ({
        variables: {
          offerId: match.params.id,
        },
      }),
    })
  )(OfferInvestments)
);



// WEBPACK FOOTER //
// ./src/components/OfferOverview/OfferInvestments.js